import React from 'react';
import PropTypes from 'prop-types';

import { amount } from 'common/propTypes';
import { orderStatus } from 'payments/propTypes';
import FormattedDate from 'common/components/FormattedDate';
import Separator from 'common/components/Separator';
import Heading from 'common/components/Heading';
import StatusTag from 'common/components/StatusTag';
import ViewProperty from 'common/components/ViewProperty';
import Text from 'common/components/Text';

import DetailsFooter from '../DetailsFooter';
import OffRampLinkDetails from '../OffRampLinkDetails';

import styles from './index.module.css';

const OffRampDetails = ({
  createdAt,
  description,
  offRampUrl,
  reference,
  status,
  totalAmount,
  tradedAmount,
}) => (
  <div className={styles.root}>
    <div className={styles.panel}>
      <Heading level="3" size="3" weight="semiBold">
        Reference: {reference}
      </Heading>
      <div className={styles.status}>
        <StatusTag status={status} paymentType="offramp" />
      </div>
      <Text size="caption" color="rebranding-md-color-grey-60">
        <FormattedDate value={createdAt} />
      </Text>
      <div className={styles.separator}>
        <Separator />
      </div>
      <ViewProperty label="Description " value={description || '-'} />
      <div className={styles.linkDetails}>
        <h4 className={styles.offRampLinkLabel}>Off ramp link</h4>
        <OffRampLinkDetails offRampUrl={offRampUrl} />
      </div>
    </div>
    <DetailsFooter totalAmount={totalAmount} originalAmount={tradedAmount} />
  </div>
);

const offRampDetailsProptypes = {
  createdAt: PropTypes.string.isRequired,
  description: PropTypes.string,
  reference: PropTypes.string.isRequired,
  status: orderStatus.isRequired,
  totalAmount: amount.isRequired,
  tradedAmount: amount,
  offRampUrl: PropTypes.string.isRequired,
};

OffRampDetails.propTypes = offRampDetailsProptypes;

export default OffRampDetails;

export { offRampDetailsProptypes };
